// Email Layout Components
export { EmailLayout } from './components/EmailLayout';
export { EmailButton } from './components/EmailButton';
export { EmailSignature } from './components/EmailSignature';
export { EmailTrackingPixel } from './components/EmailTrackingPixel';

// Email Templates
export { default as WelcomeEmail } from './templates/WelcomeEmail';
export { default as WelcomeSubscriberEmail } from './templates/WelcomeSubscriberEmail';
export { default as UnsubscribedEmail } from './templates/UnsubscribedEmail';
export { default as ResubscribedEmail } from './templates/ResubscribedEmail';
export { default as LocationContactEmail } from './templates/LocationContactEmail';
export { default as LocationPreviewEmail } from './templates/LocationPreviewEmail';
export { default as WebsiteContactEmail } from './templates/WebsiteContactEmail';

// Email Template Metadata
export const emailTemplates = {
  'welcome-community-v1': {
    component: 'WelcomeEmail',
    subject: "Welcome to the SaunaDip Community! 🔥❄️",
    variables: ['name', 'action_url', 'unsubscribe_url'],
    description: 'Sent to a new user upon signing up'
  },
  'password-reset-v1': {
    component: 'PasswordResetEmail',
    subject: "Having trouble logging in? 🔑",
    variables: ['name', 'action_url'],
    description: 'Sent when a user requests to reset their password'
  },
  'welcome-operator-v1': {
    component: 'WelcomeOperatorEmail',
    subject: "Welcome to the SaunaDip Operator Program! 🏢",
    variables: ['name', 'action_url'],
    description: 'Sent to a new user who signs up as an operator'
  },
  'location-contact-v1': {
    component: 'LocationContactEmail',
    subject: 'New contact request for your location',
    variables: ['name', 'location_name', 'contact_message', 'contact_email', 'contact_phone', 'action_url'],
    description: 'Sent to a location owner when a user contacts them via SaunaDip'
  },
  'location-preview-v1': {
    component: 'LocationPreviewEmail',
    subject: 'Preview: [Location Name]',
    variables: ['name', 'location_name', 'location_address', 'location_description', 'location_features', 'action_url'],
    description: 'Sent to a user previewing a location'
  },
  'preferences-v1': {
    component: 'PreferencesEmail',
    subject: 'Your SaunaDip preferences have been updated',
    variables: ['name', 'updated_preferences', 'action_url'],
    description: 'Sent when a user updates their email/content preferences'
  },
  'subscription-error-v1': {
    component: 'SubscriptionErrorEmail',
    subject: 'There was a problem with your SaunaDip subscription',
    variables: ['name', 'error_message', 'action_url'],
    description: 'Sent when there is a problem with a paid subscription'
  },
  'website-contact-v1': {
    component: 'WebsiteContactEmail',
    subject: 'New website contact',
    variables: ['name', 'email', 'message'],
    description: 'Sent to SaunaDip when a user contacts via the website'
  },
  'welcome-subscriber-v1': {
    component: 'WelcomeSubscriberEmail',
    subject: 'Welcome to the SaunaDip newsletter!',
    variables: ['name', 'action_url', 'unsubscribe_url'],
    description: 'Sent when a user subscribes to the newsletter'
  },
}; 